import DefaultImg from "../../../../assets/img/default-image.svg";
import { TVacancy } from "../../../../store/vacancy/types";
import { capitalizeName } from "../../../../utils/stringUtils";
import CustomButton from "../../../UI/Buttons/CustomButton";
import StarRating from "../../../UI/StarRating";

const SelectedCandidateCard = ({
  selectedVacancyDetails,
  isAdmin,
  onViewProfile,
}: {
  selectedVacancyDetails: TVacancy | null;
  isAdmin: boolean;
  onViewProfile: () => {};
}) => {
  const { centre, selected_candidate } = selectedVacancyDetails || {};

  return (
    <div className="bg-white border border-grey-light radius-8px p-15px d-flex flex-column flex-lg-row gap-30 gap-mobile-10 align-items-lg-center text-break">
      <div className="d-flex gap-20 align-items-center">
        <div className="w-50px h-50px  radius-50px">
          <img
            alt="Candidate"
            width="50px"
            height="50px"
            className="img-responsive rounded-circle object-fit-cover"
            src={selected_candidate?.photo || DefaultImg}
          />
        </div>
        <div className="d-flex flex-column gap-3">
          <div className="fs-16 fw-700 text-black">
            {capitalizeName(selected_candidate?.first_name ?? "")} {capitalizeName(selected_candidate?.last_name ?? "")}
          </div>
          <div className="fs-13 fw-400 text-black">
            {selected_candidate?.designation}
          </div>
        </div>
      </div>
      <StarRating
        rating={
          isAdmin
            ? selected_candidate?.rating?.average_rating || 0
            : selected_candidate?.rating?.latest_rating ||
              selected_candidate?.rating?.average_rating ||
              0
        }
        color={
          isAdmin || !selected_candidate?.rating?.latest_rating
            ? "#aaaaaa"
            : "#51C2B9"
        }
      />
      {!isAdmin &&
        !selected_candidate?.rating?.latest_rating &&
        selected_candidate?.rating?.average_rating && (
          <div className="fs-10 fw-400 text-grey-dark">Average Rating</div>
        )}
      {Boolean(selected_candidate?.is_preferred) ? (
        <div
          className={`border border-teal-dark bg-teal-pale py-4px px-8px radius-8px fs-13 text-teal-dark text-nowrap me-auto`}
        >
          <div className={`fs-13 fw-400 text-teal-dark`}>Preferred</div>
        </div>
      ) : 
        <div className="me-auto"></div> 
      }
      <CustomButton
        variant={"primary"}
        type="button"
        className="btn-theme bg-teal text-black text-nowrap"
        onClick={onViewProfile}
      >
        View Profile
      </CustomButton>
    </div>
  );
};

export default SelectedCandidateCard;
